<template>
  <HubContainer id="globalReportsHub">

    <HubSection icon="icon/hub/statistics.svg" v-if="atLeastDistributor && !isCompanyLevel" :large="!atLeastSuperAdmin"
                :title="$t('statistics.title')"
                :description="$t('statistics.description')"
                :buttonAction="goToStats">
    </HubSection>

    <!--Superadmin Section-->
    <template v-if="atLeastSuperAdmin && !(isBranchLevel || isCompanyLevel)">

      <HubSection icon="icon/hub/customer.svg"
                  :title="$t('advanced_navigation.customer_report')"
                  :description="$t('advanced_navigation.customer_report_description')"
                  :buttonAction="goToCustomers">
      </HubSection>

      <HubSection icon="icon/hub/sms-reports.svg"
                  :title="$t('advanced_navigation.sms_Report')"
                  :description="$t('advanced_navigation.sms_Report_description')"
                  :buttonAction="goToSms">
      </HubSection>

      <HubSection icon="icon/hub/payment-reports.svg"
                  :title="$t('advanced_navigation.stats_payment')"
                  :description="$t('advanced_navigation.stats_payment_description')"
                  :buttonAction="goToStatsPayment">
      </HubSection>

      <HubSection icon="icon/hub/anomaly-reports.svg"
                  :title="$t('advanced_navigation.anomaly_reports')"
                  :description="$t('advanced_navigation.anomaly_reports_description')"
                  :buttonAction="goToAnomaly">
      </HubSection>
    </template>

    <!--Branchadmin Section-->
    <template v-if="isBranchLevel && !isCompanyLevel && atLeastBranchAdmin">
      <HubSection icon="icon/hub/organization-stats.svg"
                  :title="$t('statistics.branch_title')"
                  :description="$t('statistics.branch_description')"
                  :buttonAction="goToBranchStats">
      </HubSection>

      <HubSection icon="icon/hub/customer.svg"
                  :title="$t('advanced_navigation.customer_report')"
                  :description="$t('advanced_navigation.customer_hub_description')"
                  :buttonAction="goToBranchCustomersHub">
      </HubSection>

      <HubSection icon="icon/hub/inventory-unavailability.svg" v-if="multiInventoryActivated"
                  :title="$t('inventory_out_of_stock_report.title')"
                  :description="$t('inventory_out_of_stock_report.description')"
                  :buttonAction="goToInventoryOOS">
      </HubSection>
    </template>

    <!--companyAdmin Section-->
    <template v-if="isCompanyLevel && atLeastCompanyAdmin">
      <HubSection icon="icon/hub/schedules.svg" v-if="moduleActivated.POS"
                  :title="$t('timesheet.punch_admin')"
                  :description="$t('timesheet.overview_subtitle')"
                  :buttonAction="goToPunchReport">
      </HubSection>

      <HubSection icon="icon/hub/statistics.svg" v-if="moduleActivated.onlineOrdering || moduleActivated.kiosk"
                  :title="$t('stats.title')"
                  :description="$t('statistics.description')"
                  :buttonAction="goToCompanyStats">
      </HubSection>

      <HubSection icon="icon/hub/categories.svg" v-if="moduleActivated.catering"
                  :title="$t('catering.title')"
                  :description="$t('catering.description')"
                  :buttonAction="goToCateringHub">
      </HubSection>

      <HubSection icon="icon/hub/categories.svg" v-if="moduleActivated.aimsVouchers"
                  :title="$t('custom_reports.codes_sales')"
                  :description="$t('custom_reports.codes_sales_description')"
                  :buttonAction="goToTicketReports">
      </HubSection>

      <HubSection icon="icon/hub/invoices.svg" v-if="moduleActivated.POS"
                  :title="$t('batch_reading.title')"
                  :description="$t('batch_reading.subtitle')"
                  :buttonAction="goToCashBatchReadings">
      </HubSection>
    </template>

    <!--Both company and branch level-->
    <template v-if="(isBranchLevel || isCompanyLevel) && atLeastCompanyAdmin">
      <HubSection icon="icon/hub/online-ordering.svg"
                  :title="$t('sales.title')"
                  :description="$t('sales.description')"
                  :buttonAction="goToSalesHub">
      </HubSection>

      <template v-if="!exactlyDistributor && moduleActivated.loyalty">
        <HubSection icon="icon/hub/qr-payment.svg" v-if="isGiftCardActivated"
                    :title="$t('gift_card.title')"
                    :description="$t('gift_card.description')"
                    :buttonAction="goToGiftCardsReports">
        </HubSection>

        <HubSection icon="icon/hub/sales.svg"
                    :title="$t('loyalty_transactions.reports_title')"
                    :description="$t('loyalty_transactions.reports_description')"
                    :buttonAction="goToLoyaltyTransactionStats">
        </HubSection>
      </template>

      <template v-if="moduleActivated.POS">
        <HubSection icon="icon/hub/ticket.svg"
                    :title="$t('pos.tip_management.title')"
                    :description="$t('pos.tip_management.description')"
                    :buttonAction="goToTipManagement">
        </HubSection>

        <HubSection icon="icon/hub/pos-help.svg"
                    :title="$t('pos.cash_drawer.management_title')"
                    :description="$t('pos.cash_drawer.management_description')"
                    :buttonAction="goToCashDrawerManagement">
        </HubSection>

        <HubSection icon="icon/hub/taxes-group.svg"
                    :title="$t('pos.price_adjustments')"
                    :description="$t('pos.price_adjustments_description')"
                    :buttonAction="goToPriceAdjustments">
        </HubSection>

        <HubSection icon="icon/hub/payment-reports.svg"
                    :title="$t('pos.refunds')"
                    :description="$t('pos.refunds_description')"
                    :buttonAction="goToRefunds">
        </HubSection>

        <HubSection icon="icon/hub/failed-sales.svg"
                    :title="$t('pos.voids')"
                    :description="$t('pos.voids_description')"
                    :buttonAction="goToVoids">
        </HubSection>
      </template>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "globalReportsHub",

    components: {HubSection, HubContainer},

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.global_reports";
      this.$store.state.pageIcon = "/icon/nav/analytics.svg";

      if (this.isBranchLevel) {
        let branchModule = await this.$store.getters.getContextBranchActivatedModule;
        Object.assign(this.moduleActivated, branchModule);
      }

      if (this.isCompanyLevel) {
        let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
        Object.assign(this.moduleActivated, companyModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
      atLeastDistributor() {
        return this.$store.getters.loggedUserHasDistributor;
      },
      atLeastBranchAdmin() {
        return this.$store.getters.loggedUserHasBranchAdmin;
      },
      atLeastCompanyAdmin() {
        return this.$store.getters.loggedUserHasCompanyAdmin;
      },
      exactlyDistributor() {
        return this.$store.state.loggedUser.isDistributor;
      },
      isBranchLevel() {
        return this.$route.query.branch;
      },
      branch() {
        return this.$store.state.contextBranch;
      },
      isCompanyLevel() {
        return this.$route.query.company;
      },
      company() {
        return this.$store.state.contextCompany;
      },
      multiInventoryActivated() {
        return this.branch ? this.branch.inventories.length > 0 : false;
      },
      isGiftCardActivated() {
        return this.branch && this.branch.loyaltyConfig && this.branch.loyaltyConfig.data && this.branch.loyaltyConfig.data.giftCardActivated;
      },
    },

    methods: {
      goToStats() {
        this.$router.push(this.$router.buildContext("/stats-builder"));
      },
      goToCustomers() {
        this.$router.push(this.$router.buildContext("/report/customer"));
      },
      goToStatsPayment() {
        this.$router.push(this.$router.buildContext("/stats-payment"));
      },
      goToSms() {
        this.$router.push(this.$router.buildContext("/sms-report"));
      },
      goToAnomaly() {
        this.$router.push(this.$router.buildContext("/anomaly-reports"));
      },
      goToBranchStats() {
        this.$router.push(this.$router.buildContext("/branch-statistics"));
      },
      goToPunchReport() {
        this.$router.push(this.$router.buildContext("/report/punch"));
      },
      goToSalesHub() {
        this.$router.push(this.$router.buildContext("/sales-hub"));
      },
      goToBranchCustomersHub() {
        this.$router.push(this.$router.buildContext("/branch-customers-hub"));
      },
      goToInventoryOOS() {
        this.$router.push(this.$router.buildContext("/report/inventory-out-of-stock"));
      },
      goToGiftCardsReports() {
        this.$router.push(this.$router.buildContext("/gift-card-reports"));
      },
      goToLoyaltyTransactionStats() {
        this.$router.push(this.$router.buildContext("/loyalty-transaction-stat"));
      },
      goToCompanyStats() {
        this.$router.push(this.$router.buildContext("/company-statistics"));
      },
      goToCateringHub() {
        this.$router.push(this.$router.buildContext("/catering-hub"));
      },
      goToTicketReports() {
        this.$router.push(this.$router.buildContext("/custom-report-qr"));
      },
      goToTipManagement() {
        this.$router.push(this.$router.buildContext("/tip-management"));
      },
      goToCashDrawerManagement() {
        this.$router.push(this.$router.buildContext("/cash-drawer-management"));
      },
      goToPriceAdjustments() {
        this.$router.push(this.$router.buildContext("/price-adjustments"));
      },
      goToRefunds() {
        this.$router.push(this.$router.buildContext("/refunds"));
      },
      goToVoids() {
        this.$router.push(this.$router.buildContext("/voids"));
      },
      goToCashBatchReadings() {
        this.$router.push(this.$router.buildContext("/batch-reading"));
      }
    }
  }
</script>